import {InputLabel, FormGroup, Paper, Switch, TextField, TableRow, TableCell, Table, Typography, FormControl, Button, MenuItem, Select, FormControlLabel, Checkbox, } from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import GetRole from "./user";
import { useAppData } from "./appDataContext.js";
import { fetchTourbyId, updateTourdata, fetchDest, uploadsinglefile, deletefile } from "../api/customerapi";

const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(60),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    textField2: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(4),
        width: theme.spacing(30),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
    headertext: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    headertext2: {
        marginTop: theme.spacing(3.5),
        
        
    },
    formgroup: {
        justifyContent: "center",   
    },
    textArea: {
        marginLeft: theme.spacing(12),
        marginRight: theme.spacing(14),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
    button: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(4),
        width: theme.spacing(15),
        height: theme.spacing(6),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
  }));

const Tourdataupdate = () => {
    var { cuser, role } = GetRole();
    const classes = useStyles();
    
    //const dispatch=useDispatch();
    const currenturl=window.location.href;
    const urlarray=currenturl.split("/");
    const currentid=urlarray[urlarray.length-1];
    const [ratedata, setratedata] = useState([]);
    const [tourData, settourData] =useState({
        tour_name: "",
        tour_duration:1,
        tour_description: "",
        tour_city: "",
        tour_destination: "",
        tour_description_transport: "",
        tour_description_inclusions: "",
        tour_description_additional: "",
        tour_description_info: "",
        });
        const [odays, setodays] =useState({
            monday:true,
            tuesday:true,
            wednesday:true,
            thursday:true,
            friday:true,
            saturday:true,
            sunday:true,
         });
        const [dest, setdest]=useState([])
        const [normal, setnormal]=useState({
            A1:0,
        A2:0,
        A3:0,
        A4:0,
        A5:0,
        A6:0,
        A7:0,
        A8:0,
        A9:0,
        A10:0,
        A1C1:0,
        A2C2:0,
        A2C1:0,
        A3C1:0,
        A3C2:0,
        A3C3:0,
        A4C1:0,
        A4C2:0,
        A4C3:0,
         A5C1:0,
            A5C2:0,
            A5C3:0,
            A6C1:0,
            A6C2:0,
            A6C3:0,
        })
        const [mid, setmid]=useState({
            A1:0,
            A2:0,
            A3:0,
            A4:0,
            A5:0,
            A6:0,
            A7:0,
            A8:0,
            A9:0,
            A10:0,
            A1C1:0,
            A2C2:0,
            A2C1:0,
            A3C1:0,
            A3C2:0,
            A3C3:0,
            A4C1:0,
            A4C2:0,
            A4C3:0,
             A5C1:0,
            A5C2:0,
            A5C3:0,
            A6C1:0,
            A6C2:0,
            A6C3:0,
        })
        const [high, sethigh]=useState({
            A1:0,
            A2:0,
            A3:0,
            A4:0,
            A5:0,
            A6:0,
            A7:0,
            A8:0,
            A9:0,
            A10:0,
            A1C1:0,
            A2C2:0,
            A2C1:0,
            A3C1:0,
            A3C2:0,
            A3C3:0,
            A4C1:0,
            A4C2:0,
            A4C3:0,
            A5C1:0,
            A5C2:0,
            A5C3:0,
            A6C1:0,
            A6C2:0,
            A6C3:0,
        })
        const { appData, loading } = useAppData();
        const [cities, setcities]=useState([])
        const [filedetails, setfiledetails] = useState({
            filetype:"",
            file:null,
          });
          const [finalfiledetails, setfinalfiledetails] = useState([]);

    const getTour = async (id) => {
        try{
        const data = await fetchTourbyId(id);
        setratedata(data.data.rate_category)
        setnormal(data.data.normal)
        setmid(data.data.mid)
        sethigh(data.data.high)
        setfinalfiledetails(data.data.file)
        if("active_tour" in data.data){
          settourData(data.data)
        }else{
          settourData({...data.data, active_tour:true})
        }
        if("operating_days" in data.data){
            setodays(data.data.operating_days)
        }   
    }catch(err){
        console.log(err)
      }
    }
    const getDest = async () => {
        try{
        const data = await fetchDest();
        const temp=data.data.filter(d=>"order" in d)
        setdest(temp[0].dest);
      }catch(err){
        console.log(err)
      }
      };

    const getCities = async () => {
        try{
        const data = await fetchDest();
        //console.log(data.data);
        const citylist= data.data.map(arr => arr.dest[0] == tourData.tour_destination ? [arr.cities] : [])
        const citylist2=citylist?.filter(arr => arr.length !==0 )
        const citylist3=citylist2[0]
      
      
        setcities(citylist3 ? [...citylist3[0]] :[])
    }catch(err){
        console.log(err)
      }
       
    }

    useEffect(() => {
        getTour(currentid)
        getDest()
    }, [])

    useEffect(() => {
        
        getCities()
        
    }, [tourData])
   

    const handleSubmit =async (e) => {
        try{
        e.preventDefault();
        const finaltourData={...tourData, normal:normal, mid:mid, high:high, operating_days:odays, file:finalfiledetails, rate_category:ratedata}
        const updatetourResponse= await updateTourdata(tourData._id, finaltourData);
        //console.log(tourData)
        if(updatetourResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
            alert("Data updated for tour with tour id "+updatetourResponse.data.tour_id);
            window.location = ("/tourdataentry/"+updatetourResponse.data.tour_id);
        }
        else{
            alert("Something went wrong. Contact support");
            window.location = ("/");
        }
    }catch(err){
        console.log(err)
      } 
    }

    const handleSubmit3 =async (data) => {
        try{
   
        const finaltourData={...tourData, normal:normal, mid:mid, high:high, operating_days:odays, file: data}
        const updatetourResponse= await updateTourdata(tourData._id, finaltourData);
        //console.log(tourData)
        if(updatetourResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
            alert("Data updated for tour with tour id "+updatetourResponse.data.tour_id);
            window.location = ("/tourdataentry/"+updatetourResponse.data.tour_id);
        }
        else{
            alert("Something went wrong. Contact support");
            window.location = ("/");
        }
    }catch(err){
        console.log(err)
      } 
    }

    const handleFileInput = (e) => {
        //console.log(e)
        const formdata=new FormData()
        formdata.append("myFile",e.target.files[0],e.target.files[0].name)
        //console.log(formdata)
        setfiledetails({...filedetails, file:formdata, filetype:e.target.id});
      }
    
      const uploadfile=async()=>{
        //console.log(filedetails)
        try{
          const data=await uploadsinglefile(filedetails.file)
          console.log(data.data)
          if(data.data.name){
            alert("File "+data.data.name+" uploaded succesfully")
          }else{
            alert("Error while uploading")
          }
          const temp={
            location:data.data.location,
            name:data.data.name,
            type_of_doc:filedetails.filetype,
            uploadtime:new Date(),
          }
          setfinalfiledetails([...finalfiledetails, temp])
        }catch(e){
          console.log(e)
        }
        
      }
      
      const deletefile2=async(name)=>{
        try{
          //console.log(name)
          const data=await deletefile({name:name})
          alert(data.data.msg)
          if(data.data.msg=="File deleted successfully"){
            const temp=finalfiledetails.filter(f=>f.name!==name)
            //setfinalfiledetails(temp)
            handleSubmit3(temp)
          }
      
      }catch(e){
        console.log(e)
      }
      }

      const startdatechange = (e, tid, id) => {
        const newdata = ratedata[tid];
        //console.log(newdata)
        const newitem = { ...newdata, start_date: e.target.value };
        //console.log(newitem)
        setratedata(ratedata.map((item) => ("id" in item && item.id == id ? newitem : item)));
        //setdata([...data, data[tid]=newitem])
        // console.log(cpdata)
      };

      const enddatechange = (e, tid, id) => {
        const newdata = ratedata[tid];
        // console.log(tid, id)
        const newitem = { ...newdata, end_date: e.target.value };
        // console.log(newitem)
        setratedata(ratedata.map((item) => ("id" in item && item.id == id ? newitem : item)));
        //setdata([...data, data[tid]=newitem])
        // console.log(cpdata)
      };

      const categorychange = (e, tid, id) => {
        const newdata = ratedata[tid];
        console.log(tid, id)
        const newitem = { ...newdata, category: e.target.value };
        console.log(newitem)
        setratedata(ratedata.map((item) => ("id" in item && item.id == id ? newitem : item)));
        //setdata([...data, data[tid]=newitem])
        // console.log(cpdata)
      };
      console.log(ratedata)

      const addcp = () => {
        //console.log(count)
    
        setratedata(
          ratedata.length == 0 ? [{ id: uuidv4() }] : [...ratedata, { id: uuidv4() }]
        );
      };
    
      const removecp = () => {
        setratedata([...ratedata].slice(0, ratedata.length - 1));
      };

    return ( 
        <Paper variant="outlined" className={classes.paper} elevation={10}>
         {/* <FormControlLabel control={<Checkbox color="primary"/>}  checked={"active_tour" in tourData?tourData.active_tour:false} value={"active_tour" in tourData?tourData.active_tour:false} label="Active?" onChange={(e)=> settourData({...tourData, active_tour: !tourData.active_tour})}></FormControlLabel> */}
            <Typography variant="h4" align="center" className={classes.headertext}> Update Tour (Tour ID:{tourData.tour_id})</Typography>
            <form onSubmit={handleSubmit}>
            
            <FormGroup row className={classes.formgroup}>
                <TextField variant="standard"  label="Name"  InputLabelProps={{ shrink: true }} value={tourData.tour_name} className={classes.textField} onChange={(e)=> settourData({...tourData, tour_name: e.target.value})}/>
                
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="primary destination">Destination *</InputLabel>
                <Select displayEmpty classname={classes.textField} labelId="primary destination" required InputLabelProps={{ shrink: true }} value={tourData.tour_destination} onChange={(e)=> settourData({...tourData, tour_destination: e.target.value})}>
                    {dest.map(dest => {
                    return <MenuItem value={dest}>{dest}</MenuItem>})}
                    
                </Select>
                </FormControl>
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="city">City *</InputLabel>
                <Select displayEmpty classname={classes.textField} required labelId="city" InputLabelProps={{ shrink: true }} value={tourData.tour_city} onChange={(e)=> settourData({...tourData, tour_city: e.target.value})}>
                    {cities?.map(city => {
                    return <MenuItem value={city}>{city}</MenuItem>})}
                    
                </Select>
                </FormControl>
            
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
            <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Duration">Duration (number)</InputLabel>
                <Select displayEmpty classname={classes.textField} labelId="Duration" value={tourData.tour_duration} onChange={(e)=> settourData({...tourData, tour_duration: e.target.value})}>
                    <MenuItem value={0.5}>0.5</MenuItem>
                    <MenuItem value={1}>1</MenuItem>
                 
                    
                </Select>
                </FormControl>
                <TextField variant="standard"  label="Start Time"  InputLabelProps={{ shrink: true }} value={tourData.start_time} className={classes.textArea}  onChange={(e)=> settourData({...tourData, start_time: e.target.value})}/>
                <TextField variant="standard"  label="End Time"  InputLabelProps={{ shrink: true }} value={tourData.end_time} className={classes.textArea}  onChange={(e)=> settourData({...tourData, end_time: e.target.value})}/>
                <FormControlLabel control={<Switch checked={"tour_status" in tourData?tourData.tour_status:false} color="secondary" onChange={(e)=>settourData({...tourData, tour_status:e.target.checked})}/>}  label="Suspended?" />
                <FormControlLabel control={<Switch checked={"advance_booking" in tourData?tourData.advance_booking:false} color="primary" onChange={(e)=>settourData({...tourData, advance_booking:e.target.checked})}/>}  label="Advance Booking?" />
                {/* <Switch  onChange={()=>settourData({...tourData, tour_status:!tourData.tour_status})} color="secondary" label="Suspended?"/> */}
                </FormGroup>
                <FormGroup row className={classes.formgroup}>
                <Typography variant="h6"  className={classes.headertext}> Operating Days:   </Typography>
                <FormControlLabel control={<Checkbox color="primary"/>}  value={"monday" in odays?odays.monday:false} checked={"monday" in odays?odays.monday:false} label="Monday" onChange={(e)=> setodays({...odays, monday:e.target.checked})}/>
                <FormControlLabel control={<Checkbox color="primary"/>}  value={"tuesday" in odays?odays.tuesday:false} checked={"tuesday" in odays?odays.tuesday:false} label="Tuesday" onChange={(e)=> setodays({...odays, tuesday:e.target.checked})}/>
                <FormControlLabel control={<Checkbox color="primary"/>}  value={"wednesday" in odays?odays.wednesday:false} checked={"wednesday" in odays?odays.wednesday:false} label="Wednesday" onChange={(e)=> setodays({...odays, wednesday:e.target.checked})}/>
                <FormControlLabel control={<Checkbox color="primary"/>}  value={"thursday" in odays?odays.thursday:false} checked={"thursday" in odays?odays.thursday:false} label="Thursday" onChange={(e)=> setodays({...odays, thursday:e.target.checked})}/>
                <FormControlLabel control={<Checkbox color="primary"/>}  value={"friday" in odays?odays.friday:false} checked={"friday" in odays?odays.friday:false} label="Friday" onChange={(e)=> setodays({...odays, friday:e.target.checked})}/>
                <FormControlLabel control={<Checkbox color="primary"/>}  value={"saturday" in odays?odays.saturday:false} checked={"saturday" in odays?odays.saturday:false} label="Saturday" onChange={(e)=> setodays({...odays, saturday:e.target.checked})}/>
                <FormControlLabel control={<Checkbox color="primary"/>}  value={"sunday" in odays?odays.sunday:false} checked={"sunday" in odays?odays.sunday:false} label="Sunday" onChange={(e)=> setodays({...odays, sunday:e.target.checked})}/>
                </FormGroup>
                <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined"  label={"tour_description" in tourData && tourData.tour_description?"Description - "+tourData.tour_description.length:"Description"}  InputLabelProps={{ shrink: true }} value={tourData.tour_description} className={classes.textArea} fullWidth multiline rows={4} onChange={(e)=> settourData({...tourData, tour_description: e.target.value})}/>
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined"  label={"tour_description_transport" in tourData && tourData.tour_description_transport?"Transport - "+tourData.tour_description_transport.length:"Transport"}  InputLabelProps={{ shrink: true }} value={tourData.tour_description_transport} className={classes.textArea} fullWidth multiline rows={2} onChange={(e)=> settourData({...tourData, tour_description_transport: e.target.value})}/>
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined"  label={"tour_description_inclusions" in tourData && tourData.tour_description_inclusions?"Inclusions - "+tourData.tour_description_inclusions.length:"Inclusions"}  InputLabelProps={{ shrink: true }} value={tourData.tour_description_inclusions} className={classes.textArea} fullWidth multiline rows={4} onChange={(e)=> settourData({...tourData, tour_description_inclusions: e.target.value})}/>
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined"  label={"tour_description_additional" in tourData && tourData.tour_description_additional?"Additional Items - "+tourData.tour_description_additional.length:"Additional Items"}  InputLabelProps={{ shrink: true }} value={tourData.tour_description_additional} className={classes.textArea} fullWidth multiline rows={4} onChange={(e)=> settourData({...tourData, tour_description_additional: e.target.value})}/>
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined"  label={"tour_description_info" in tourData && tourData.tour_description_info?"Important Information - "+tourData.tour_description_info.length:"Important Information"}  InputLabelProps={{ shrink: true }} value={tourData.tour_description_info} className={classes.textArea} fullWidth multiline rows={4} onChange={(e)=> settourData({...tourData, tour_description_info: e.target.value})}/>
              
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined"  label={"tour_internal_note" in tourData && tourData.tour_internal_note?"Internal Note - "+tourData.tour_internal_note.length:"Internal Note"}  InputLabelProps={{ shrink: true }} value={tourData.tour_internal_note} className={classes.textArea} fullWidth multiline rows={2} onChange={(e)=> settourData({...tourData, tour_internal_note: e.target.value})}/>
              
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined"  label={"tour_itinerary_text" in tourData && tourData.tour_itinerary_text?"Itinerary Text - "+tourData.tour_itinerary_text.length:"Itinerary Text"}  InputLabelProps={{ shrink: true }} value={tourData.tour_itinerary_text} className={classes.textArea} fullWidth multiline rows={2} onChange={(e)=> settourData({...tourData, tour_itinerary_text: e.target.value})}/>
              
            </FormGroup>
            {role=="Admin" || role=="Product" || role=="Operations" || role=="Operations-TL"?(<div>
            <FormGroup row className={classes.formgroup}>
            <h4 className={classes.headtext}>Upload Image 1:</h4>
            <input type="file" name="myFile" id="image1" onChange={(e)=>handleFileInput(e)}/>
            <h4 className={classes.headtext}>Upload Image 2:</h4>
            <input type="file" name="myFile" id="image2" onChange={(e)=>handleFileInput(e)}/>
            <h4 className={classes.headtext}>Upload Image 3:</h4>
            <input type="file" name="myFile" id="image3" onChange={(e)=>handleFileInput(e)}/>
            <Button
            variant="contained"
            color="primary"
            onClick={uploadfile}
            className={classes.button}
          >
                Upload
          </Button>
            </FormGroup>
            <br></br>
            <br></br>
            <FormGroup row className={classes.formgroup}>
               
                <Table>
                {finalfiledetails.map(f=> {
          return(
            
            <TableRow>
            <TableCell>
                {f.type_of_doc}
            </TableCell>
                <TableCell>
                <a href={f.location}><img src={f.location} height="100px" width="100px" alt="image1"/></a>
                </TableCell>
                <Button
            variant="contained"
            color="secondary"
            onClick={()=>deletefile2(f.name)}
            className={classes.smallbutton2}
          >
         Delete
          </Button>
              </TableRow>
          )})}
          </Table>
            </FormGroup>
            <br></br>
            <br></br>
            <Typography variant="h4" align="center" className={classes.headertext}> Rate Category</Typography>
            {ratedata.map(item=>{
                return (<div>
                    <FormGroup row className={classes.formgroup}>
                    <TextField
            required
            variant="standard"
            type="date"
            label={"Start Date"}
            id={ratedata.indexOf(item)}
            InputLabelProps={{ shrink: true }}
            value={
                      item.start_date === undefined
                        ? ""
                        : item.start_date.split("T").slice(0, 1)
                    }
            className={classes.textField2}
            onChange={(e) => startdatechange(e, e.target.id, item.id)}
          />
          <TextField
            required
            variant="standard"
            type="date"
            label={"End Date"}
            id={ratedata.indexOf(item)}
            InputLabelProps={{ shrink: true }}
            value={
                      item.end_date === undefined
                        ? ""
                        : item.end_date.split("T").slice(0, 1)
                    }
            className={classes.textField2}
            onChange={(e) => enddatechange(e, e.target.id, item.id)}
          />
           <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="category">Category</InputLabel>
                <Select displayEmpty classname={classes.textField} labelId="category" required  name={ratedata.indexOf(item)} InputLabelProps={{ shrink: true }} value={item.category} onChange={(e)=> categorychange(e, e.target.name, item.id)}>
                   
                  <MenuItem value={"Normal"}>Normal</MenuItem>
                  <MenuItem value={"Mid"}>Mid</MenuItem>
                  <MenuItem value={"High"}>High</MenuItem> 
                </Select>
                </FormControl>
          
                    </FormGroup>
                </div>)
            })}
            <FormGroup row className={classes.formgroup}>
            <Button
              variant="outlined"
              color="primary"
              className={classes.button}
              onClick={addcp}
            >
              {" "}
              + Tranche
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              className={classes.button}
              onClick={removecp}
            >
              {" "}
              - Tranche
            </Button>
            </FormGroup>
            <br></br>
            <br></br>
            <FormGroup row className={classes.formgroup}>
            <Typography variant="h6" className={classes.headertext}> Normal----------Mid----------High</Typography>
           
                </FormGroup>
                <FormGroup row className={classes.formgroup}>
                <Typography variant="h6" align="center" className={classes.headertext2}> 1A</Typography>
                <TextField variant="outlined"  type="Number" label="Normal 1A"  disabled={role=="Operations" || role=="Operations-TL"?1:0} value={normal?.A1?normal.A1:0} className={classes.textField2}  onChange={(e)=> setnormal({...normal, A1: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="Mid 1A" disabled={role=="Operations" || role=="Operations-TL"?1:0} value={mid?.A1?mid.A1:0} className={classes.textField2}  onChange={(e)=> setmid({...mid, A1: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="High 1A"  disabled={role=="Operations" || role=="Operations-TL"?1:0} value={high?.A1?high.A1:0} className={classes.textField2}  onChange={(e)=> sethigh({...high, A1: e.target.value})}/>
                </FormGroup>
                <FormGroup row className={classes.formgroup}>
                <Typography variant="h6" align="center" className={classes.headertext2}> 2A</Typography>
                <TextField variant="outlined"  type="Number" label="Normal 2A"   disabled={role=="Operations" || role=="Operations-TL"?1:0} value={normal?.A2} className={classes.textField2}  onChange={(e)=> setnormal({...normal, A2: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="Mid 2A"   disabled={role=="Operations" || role=="Operations-TL"?1:0} value={mid?.A2} className={classes.textField2}  onChange={(e)=> setmid({...mid, A2: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="High 2A"  disabled={role=="Operations" || role=="Operations-TL"?1:0} value={high?.A2} className={classes.textField2}  onChange={(e)=> sethigh({...high, A2: e.target.value})}/>
                </FormGroup>
                <FormGroup row className={classes.formgroup}>
                <Typography variant="h6" align="center" className={classes.headertext2}> 3A</Typography>
                <TextField variant="outlined"  type="Number" label="Normal 3A"  disabled={role=="Operations" || role=="Operations-TL"?1:0}  value={normal?.A3} className={classes.textField2}  onChange={(e)=> setnormal({...normal, A3: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="Mid 3A"  disabled={role=="Operations" || role=="Operations-TL"?1:0}  value={mid?.A3} className={classes.textField2}  onChange={(e)=> setmid({...mid, A3: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="High 3A" disabled={role=="Operations" || role=="Operations-TL"?1:0}   value={high?.A3} className={classes.textField2}  onChange={(e)=> sethigh({...high, A3: e.target.value})}/>
                </FormGroup>
                <FormGroup row className={classes.formgroup}>
                <Typography variant="h6" align="center" className={classes.headertext2}> 4A</Typography>
                <TextField variant="outlined"  type="Number" label="Normal 4A"  disabled={role=="Operations" || role=="Operations-TL"?1:0}  value={normal?.A4} className={classes.textField2}  onChange={(e)=> setnormal({...normal, A4: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="Mid 4A"  disabled={role=="Operations" || role=="Operations-TL"?1:0}  value={mid?.A4} className={classes.textField2}  onChange={(e)=> setmid({...mid, A4: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="High 4A" disabled={role=="Operations" || role=="Operations-TL"?1:0}   value={high?.A4} className={classes.textField2}  onChange={(e)=> sethigh({...high, A4: e.target.value})}/>
                </FormGroup>
                <FormGroup row className={classes.formgroup}>
                <Typography variant="h6" align="center" className={classes.headertext2}> 5A</Typography>
                <TextField variant="outlined"  type="Number" label="Normal 5A"  disabled={role=="Operations" || role=="Operations-TL"?1:0}  value={normal?.A5} className={classes.textField2}  onChange={(e)=> setnormal({...normal, A5: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="Mid 5A"  disabled={role=="Operations" || role=="Operations-TL"?1:0}  value={mid?.A5} className={classes.textField2}  onChange={(e)=> setmid({...mid, A5: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="High 5A"  disabled={role=="Operations" || role=="Operations-TL"?1:0}  value={high?.A5} className={classes.textField2}  onChange={(e)=> sethigh({...high, A5: e.target.value})}/>
                </FormGroup>
                <FormGroup row className={classes.formgroup}>
                <Typography variant="h6" align="center" className={classes.headertext2}> 6A</Typography>
                <TextField variant="outlined"  type="Number" label="Normal 6A"  disabled={role=="Operations" || role=="Operations-TL"?1:0}  value={normal?.A6} className={classes.textField2}  onChange={(e)=> setnormal({...normal, A6: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="Mid 6A"  disabled={role=="Operations" || role=="Operations-TL"?1:0}  value={mid?.A6} className={classes.textField2}  onChange={(e)=> setmid({...mid, A6: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="High 6A" disabled={role=="Operations" || role=="Operations-TL"?1:0}   value={high?.A6} className={classes.textField2}  onChange={(e)=> sethigh({...high, A6: e.target.value})}/>
                </FormGroup>
                <FormGroup row className={classes.formgroup}>
                <Typography variant="h6" align="center" className={classes.headertext2}> 7A</Typography>
                <TextField variant="outlined"  type="Number" label="Normal 7A"  disabled={role=="Operations" || role=="Operations-TL"?1:0}  value={normal?.A7} className={classes.textField2}  onChange={(e)=> setnormal({...normal, A7: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="Mid 7A"  disabled={role=="Operations" || role=="Operations-TL"?1:0}  value={mid?.A7} className={classes.textField2}  onChange={(e)=> setmid({...mid, A7: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="High 7A" disabled={role=="Operations" || role=="Operations-TL"?1:0}   value={high?.A7} className={classes.textField2}  onChange={(e)=> sethigh({...high, A7: e.target.value})}/>
                </FormGroup>
                <FormGroup row className={classes.formgroup}>
                <Typography variant="h6" align="center" className={classes.headertext2}> 8A</Typography>
                <TextField variant="outlined"  type="Number" label="Normal 8A"  disabled={role=="Operations" || role=="Operations-TL"?1:0}  value={normal?.A8} className={classes.textField2}  onChange={(e)=> setnormal({...normal, A8: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="Mid 8A"  disabled={role=="Operations" || role=="Operations-TL"?1:0} value={mid?.A8} className={classes.textField2}  onChange={(e)=> setmid({...mid, A8: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="High 8A"  disabled={role=="Operations" || role=="Operations-TL"?1:0}  value={high?.A8} className={classes.textField2}  onChange={(e)=> sethigh({...high, A8: e.target.value})}/>
                </FormGroup>
                <FormGroup row className={classes.formgroup}>
                <Typography variant="h6" align="center" className={classes.headertext2}> 9A</Typography>
                <TextField variant="outlined"  type="Number" label="Normal 9A"  disabled={role=="Operations" || role=="Operations-TL"?1:0}  value={normal?.A9} className={classes.textField2}  onChange={(e)=> setnormal({...normal, A9: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="Mid 9A"  disabled={role=="Operations" || role=="Operations-TL"?1:0}  value={mid?.A9} className={classes.textField2}  onChange={(e)=> setmid({...mid, A9: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="High 9A"  disabled={role=="Operations" || role=="Operations-TL"?1:0}  value={high?.A9} className={classes.textField2}  onChange={(e)=> sethigh({...high, A9: e.target.value})}/>
                </FormGroup>
                <FormGroup row className={classes.formgroup}>
                <Typography variant="h6" align="center" className={classes.headertext2}> 10A</Typography>
                <TextField variant="outlined"  type="Number" label="Normal 10A"  disabled={role=="Operations" || role=="Operations-TL"?1:0}  value={normal?.A10} className={classes.textField2}  onChange={(e)=> setnormal({...normal, A10: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="Mid 10A"  disabled={role=="Operations" || role=="Operations-TL"?1:0}  value={mid?.A10} className={classes.textField2}  onChange={(e)=> setmid({...mid, A10: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="High 10A"  disabled={role=="Operations" || role=="Operations-TL"?1:0}  value={high?.A10} className={classes.textField2}  onChange={(e)=> sethigh({...high, A10: e.target.value})}/>
                </FormGroup>
                <FormGroup row className={classes.formgroup}>
                <Typography variant="h6" align="center" className={classes.headertext2}> 1A1C</Typography>
                <TextField variant="outlined"  type="Number" label="Normal 1A1C" disabled={role=="Operations" || role=="Operations-TL"?1:0}  value={normal?.A1C1} className={classes.textField2}  onChange={(e)=> setnormal({...normal, A1C1: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="Mid 1A1C" disabled={role=="Operations" || role=="Operations-TL"?1:0}   value={mid?.A1C1} className={classes.textField2}  onChange={(e)=> setmid({...mid, A1C1: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="High 1A1C"  disabled={role=="Operations" || role=="Operations-TL"?1:0}  value={high?.A1C1} className={classes.textField2}  onChange={(e)=> sethigh({...high, A1C1: e.target.value})}/>
                </FormGroup>
                <FormGroup row className={classes.formgroup}>
                <Typography variant="h6" align="center" className={classes.headertext2}> 2A1C</Typography>
                <TextField variant="outlined"  type="Number" label="Normal 2A1C"  disabled={role=="Operations" || role=="Operations-TL"?1:0}  value={normal?.A2C1} className={classes.textField2}  onChange={(e)=> setnormal({...normal, A2C1: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="Mid 2A1C"  disabled={role=="Operations" || role=="Operations-TL"?1:0}  value={mid?.A2C1} className={classes.textField2}  onChange={(e)=> setmid({...mid, A2C1: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="High 2A1C"  disabled={role=="Operations" || role=="Operations-TL"?1:0}  value={high?.A2C1} className={classes.textField2}  onChange={(e)=> sethigh({...high, A2C1: e.target.value})}/>
                </FormGroup>
                <FormGroup row className={classes.formgroup}>
                <Typography variant="h6" align="center" className={classes.headertext2}> 2A2C</Typography>
                <TextField variant="outlined"  type="Number" label="Normal 2A2C"  disabled={role=="Operations" || role=="Operations-TL"?1:0}  value={normal?.A2C2} className={classes.textField2}  onChange={(e)=> setnormal({...normal, A2C2: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="Mid 2A2C"  disabled={role=="Operations" || role=="Operations-TL"?1:0}  value={mid?.A2C2} className={classes.textField2}  onChange={(e)=> setmid({...mid, A2C2: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="High 2A2C"  disabled={role=="Operations" || role=="Operations-TL"?1:0}  value={high?.A2C2} className={classes.textField2}  onChange={(e)=> sethigh({...high, A2C2: e.target.value})}/>
                </FormGroup>
                <FormGroup row className={classes.formgroup}>
                <Typography variant="h6" align="center" className={classes.headertext2}> 3A1C</Typography>
                <TextField variant="outlined"  type="Number" label="Normal 3A1C"  disabled={role=="Operations" || role=="Operations-TL"?1:0}  value={normal?.A3C1} className={classes.textField2}  onChange={(e)=> setnormal({...normal, A3C1: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="Mid 3A1C"  disabled={role=="Operations" || role=="Operations-TL"?1:0}  value={mid?.A3C1} className={classes.textField2}  onChange={(e)=> setmid({...mid, A3C1: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="High 3A1C"  disabled={role=="Operations" || role=="Operations-TL"?1:0}  value={high?.A3C1} className={classes.textField2}  onChange={(e)=> sethigh({...high, A3C1: e.target.value})}/>
                </FormGroup>
                <FormGroup row className={classes.formgroup}>
                <Typography variant="h6" align="center" className={classes.headertext2}> 3A2C</Typography>
                <TextField variant="outlined"  type="Number" label="Normal 3A2C"  disabled={role=="Operations" || role=="Operations-TL"?1:0}  value={normal?.A3C2} className={classes.textField2}  onChange={(e)=> setnormal({...normal, A3C2: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="Mid 3A2C"  disabled={role=="Operations" || role=="Operations-TL"?1:0}  value={mid?.A3C2} className={classes.textField2}  onChange={(e)=> setmid({...mid, A3C2: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="High 3A2C"  disabled={role=="Operations" || role=="Operations-TL"?1:0}  value={high?.A3C2} className={classes.textField2}  onChange={(e)=> sethigh({...high, A3C2: e.target.value})}/>
                </FormGroup>
                <FormGroup row className={classes.formgroup}>
                <Typography variant="h6" align="center" className={classes.headertext2}> 3A3C</Typography>
                <TextField variant="outlined"  type="Number" label="Normal 3A3C"  disabled={role=="Operations" || role=="Operations-TL"?1:0} value={normal?.A3C3} className={classes.textField2}  onChange={(e)=> setnormal({...normal, A3C3: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="Mid 3A3C"  disabled={role=="Operations" || role=="Operations-TL"?1:0} value={mid?.A3C3} className={classes.textField2}  onChange={(e)=> setmid({...mid, A3C3: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="High 3A3C"  disabled={role=="Operations" || role=="Operations-TL"?1:0} value={high?.A3C3} className={classes.textField2}  onChange={(e)=> sethigh({...high, A3C3: e.target.value})}/>
                </FormGroup>
                <FormGroup row className={classes.formgroup}>
                <Typography variant="h6" align="center" className={classes.headertext2}> 4A1C</Typography>
                <TextField variant="outlined"  type="Number" label="Normal 4A1C"  disabled={role=="Operations" || role=="Operations-TL"?1:0} value={normal?.A4C1} className={classes.textField2}  onChange={(e)=> setnormal({...normal, A4C1: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="Mid 4A1C"  disabled={role=="Operations" || role=="Operations-TL"?1:0} value={mid?.A4C1} className={classes.textField2}  onChange={(e)=> setmid({...mid, A4C1: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="High 4A1C"  disabled={role=="Operations" || role=="Operations-TL"?1:0} value={high?.A4C1} className={classes.textField2}  onChange={(e)=> sethigh({...high, A4C1: e.target.value})}/>
                </FormGroup>
                <FormGroup row className={classes.formgroup}>
                <Typography variant="h6" align="center" className={classes.headertext2}> 4A2C</Typography>
                <TextField variant="outlined"  type="Number" label="Normal 4A2C"  disabled={role=="Operations" || role=="Operations-TL"?1:0} value={normal?.A4C2} className={classes.textField2}  onChange={(e)=> setnormal({...normal, A4C2: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="Mid 4A2C"  disabled={role=="Operations" || role=="Operations-TL"?1:0} value={mid?.A4C2} className={classes.textField2}  onChange={(e)=> setmid({...mid, A4C2: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="High 4A2C"  disabled={role=="Operations" || role=="Operations-TL"?1:0} value={high?.A4C2} className={classes.textField2}  onChange={(e)=> sethigh({...high, A4C2: e.target.value})}/>
                </FormGroup>
                <FormGroup row className={classes.formgroup}>
                <Typography variant="h6" align="center" className={classes.headertext2}> 4A3C</Typography>
                <TextField variant="outlined"  type="Number" label="Normal 4A3C"  disabled={role=="Operations" || role=="Operations-TL"?1:0} value={normal?.A4C3} className={classes.textField2}  onChange={(e)=> setnormal({...normal, A4C3: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="Mid 4A3C"  disabled={role=="Operations" || role=="Operations-TL"?1:0} value={mid?.A4C3} className={classes.textField2}  onChange={(e)=> setmid({...mid, A4C3: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="High 4A3C"  disabled={role=="Operations" || role=="Operations-TL"?1:0} value={high?.A4C3} className={classes.textField2}  onChange={(e)=> sethigh({...high, A4C3: e.target.value})}/>
                </FormGroup>
                <FormGroup row className={classes.formgroup}>
                <Typography variant="h6" align="center" className={classes.headertext2}> 5A1C</Typography>
                <TextField variant="outlined"  type="Number" label="Normal 5A1C"  disabled={role=="Operations" || role=="Operations-TL"?1:0} value={normal?.A5C1} className={classes.textField2}  onChange={(e)=> setnormal({...normal, A5C1: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="Mid 5A1C"  disabled={role=="Operations" || role=="Operations-TL"?1:0} value={mid?.A5C1} className={classes.textField2}  onChange={(e)=> setmid({...mid, A5C1: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="High 5A1C"  disabled={role=="Operations" || role=="Operations-TL"?1:0} value={high?.A5C1} className={classes.textField2}  onChange={(e)=> sethigh({...high, A5C1: e.target.value})}/>
                </FormGroup>
                <FormGroup row className={classes.formgroup}>
                <Typography variant="h6" align="center" className={classes.headertext2}> 5A2C</Typography>
                <TextField variant="outlined"  type="Number" label="Normal 5A2C"  disabled={role=="Operations" || role=="Operations-TL"?1:0} value={normal?.A5C2} className={classes.textField2}  onChange={(e)=> setnormal({...normal, A5C2: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="Mid 5A2C"  disabled={role=="Operations" || role=="Operations-TL"?1:0} value={mid?.A5C2} className={classes.textField2}  onChange={(e)=> setmid({...mid, A5C2: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="High 5A2C"  disabled={role=="Operations" || role=="Operations-TL"?1:0} value={high?.A5C2} className={classes.textField2}  onChange={(e)=> sethigh({...high, A5C2: e.target.value})}/>
                </FormGroup>
                <FormGroup row className={classes.formgroup}>
                <Typography variant="h6" align="center" className={classes.headertext2}> 5A3C</Typography>
                <TextField variant="outlined"  type="Number" label="Normal 5A3C"  disabled={role=="Operations" || role=="Operations-TL"?1:0} value={normal?.A5C3} className={classes.textField2}  onChange={(e)=> setnormal({...normal, A5C3: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="Mid 5A3C"  disabled={role=="Operations" || role=="Operations-TL"?1:0} value={mid?.A5C3} className={classes.textField2}  onChange={(e)=> setmid({...mid, A5C3: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="High 5A3C"  disabled={role=="Operations" || role=="Operations-TL"?1:0} value={high?.A5C3} className={classes.textField2}  onChange={(e)=> sethigh({...high, A5C3: e.target.value})}/>
                </FormGroup>
                <FormGroup row className={classes.formgroup}>
                <Typography variant="h6" align="center" className={classes.headertext2}> 6A1C</Typography>
                <TextField variant="outlined"  type="Number" label="Normal 6A1C"  disabled={role=="Operations" || role=="Operations-TL"?1:0} value={normal?.A6C1} className={classes.textField2}  onChange={(e)=> setnormal({...normal, A6C1: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="Mid 6A1C"  disabled={role=="Operations" || role=="Operations-TL"?1:0} value={mid?.A6C1} className={classes.textField2}  onChange={(e)=> setmid({...mid, A6C1: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="High 6A1C"  disabled={role=="Operations" || role=="Operations-TL"?1:0} value={high?.A6C1} className={classes.textField2}  onChange={(e)=> sethigh({...high, A6C1: e.target.value})}/>
                </FormGroup>
                <FormGroup row className={classes.formgroup}>
                <Typography variant="h6" align="center" className={classes.headertext2}> 6A2C</Typography>
                <TextField variant="outlined"  type="Number" label="Normal 6A2C"  disabled={role=="Operations" || role=="Operations-TL"?1:0} value={normal?.A6C2} className={classes.textField2}  onChange={(e)=> setnormal({...normal, A6C2: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="Mid 6A2C"  disabled={role=="Operations" || role=="Operations-TL"?1:0} value={mid?.A6C2} className={classes.textField2}  onChange={(e)=> setmid({...mid, A6C2: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="High 6A2C"  disabled={role=="Operations" || role=="Operations-TL"?1:0} value={high?.A6C2} className={classes.textField2}  onChange={(e)=> sethigh({...high, A6C2: e.target.value})}/>
                </FormGroup>
                <FormGroup row className={classes.formgroup}>
                <Typography variant="h6" align="center" className={classes.headertext2}> 6A3C</Typography>
                <TextField variant="outlined"  type="Number" label="Normal 6A3C"  disabled={role=="Operations" || role=="Operations-TL"?1:0} value={normal?.A6C3} className={classes.textField2}  onChange={(e)=> setnormal({...normal, A6C3: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="Mid 6A3C"  disabled={role=="Operations" || role=="Operations-TL"?1:0} value={mid?.A6C3} className={classes.textField2}  onChange={(e)=> setmid({...mid, A6C3: e.target.value})}/>
                <TextField variant="outlined"  type="Number" label="High 6A3C"  disabled={role=="Operations" || role=="Operations-TL"?1:0} value={high?.A6C3} className={classes.textField2}  onChange={(e)=> sethigh({...high, A6C3: e.target.value})}/>
                </FormGroup>
</div>):("")}
                {"availability" in tourData && tourData.availability.length>0?(<div>
                  {tourData.availability.map(item=><div>
                    <FormGroup row className={classes.formgroup}>
                    <TextField
            
            variant="standard"
            type="date"
            label={"Start Date"}
            id={tourData.availability.indexOf(item)}
            InputLabelProps={{ shrink: true }}
            value={
                      item.start_date === undefined
                        ? ""
                        : item.start_date.split("T").slice(0, 1)
                    }
            className={classes.textField2}
           
          />
          <TextField
            
            variant="standard"
            type="date"
            label={"End Date"}
            id={tourData.availability.indexOf(item)}
            InputLabelProps={{ shrink: true }}
            value={
                      item.end_date === undefined
                        ? ""
                        : item.end_date.split("T").slice(0, 1)
                    }
            className={classes.textField2}
            
          />
             <TextField
            
            variant="standard"
            label={"Status"}
            id={tourData.availability.indexOf(item)}
            InputLabelProps={{ shrink: true }}
            value={
                      item.status
                    }
            className={classes.textField2}
            
          />
          
          
                    </FormGroup>
                  </div>)}
                </div>):("")}
           
                {role=="Admin" || role=="Product"?(
            <FormGroup row className={classes.formgroup}>
                <Button variant="contained" color="primary" type="submit" className={classes.button}>Save</Button>
                <Button href="/listtourdata" variant="contained" color="secondary" className={classes.button}>Cancel</Button>
                <Button href={"/duptourentry/"+tourData.tour_id} variant="contained" color="tertiary" className={classes.button}>Duplicate</Button>
            </FormGroup>
            ):("")}
              {"Tour added by:"+tourData.created_by}
            </form>
        </Paper>
     );
}

export default Tourdataupdate;